import type { AmplitudeEvent } from "@app/types/tracking/common";
import type {
  ClickedErrorButton,
  FailedRequest
} from "@app/types/tracking/error";

import type { ErrorModalButtonType } from "../helpers/api-error";

import * as PropertyValues from "./constants/property-values";
import { TrackingAction } from "./constants/tracking-action";

export const Transaction = {
  // Results
  POLL_DEPARTURES: "poll_departures",
  POLL_TRIPS: "poll_trips",
  CREATE_CART: "create_cart",
  ADD_RETURN_TO_CART: "add_return_to_cart",
  CREATE_BOOKING: "create_booking",
  CREATE_REFERRAL_CART: "create_referral_cart",
  REFUSE_PRICE_CHANGED: "refuse_price_changed",
  ADD_RETURN_TO_REFERRAL_CART: "add_return_to_referral_cart",
  POLL_BOOKING_STATUS: "poll_booking_status",
  RESULTS_EXPIRED: "results_expired",
  // Checkout
  UPDATE_CART_PASSENGERS: "update_cart_passengers",
  UPDATE_CART_PAYMENT: "update_cart_payment",
  UPDATE_BOOKING_PASSENGERS: "update_booking_passengers",
  UPDATE_BOOKING_PAYMENT: "update_booking_payment",
  UPDATE_DISCOUNT_CODE: "update_discount_code",
  ADD_DISCOUNT_CODE: "add_discount_code",
  REMOVE_DISCOUNT_CODE: "remove_discount_code",
  UPDATE_PURCHASE_REDIRECTION_COMPLETED:
    "update_purchase_redirection_completed",
  GENERATE_PAYMENT_TOKEN: "generate_payment_token",
  PURCHASE_CART: "purchase_cart",
  PURCHASE_BOOKING: "purchase_booking",
  POLL_PURCHASE_STATUS: "poll_purchase_status",
  REFRESH_CART_PRICE: "refresh_cart_price",
  POLL_CART_V2: "poll_cart_v2",
  ADD_ANCILLARY_ITEM: "add_ancillary_item",
  REMOVE_ANCILLARY_ITEM: "remove_ancillary_item",
  // Thank You
  POLL_PURCHASE_TICKETS: "poll_purchase_tickets",
  // Authentication
  SIGN_IN: "signin",
  SIGN_UP: "signup",
  UPDATE_USER: "update_user",
  CONFIRM_NEW_PASSWORD: "confirm_new_password",
  // Webpack
  CHUNK_PRELOAD: "chunk_preload"
} as const;

export type RequestType = (typeof Transaction)[keyof typeof Transaction];

/* Used to track when an request failed, such as polling or cart creation */
export function failedRequest(
  error: any,
  request_type: RequestType,
  other_details?: any
): AmplitudeEvent<FailedRequest> {
  return {
    action: TrackingAction.FailedRequest,
    category: "error",
    trigger: "Non-interaction event",
    details: {
      error_transaction:
        request_type || error.transaction || PropertyValues.EMPTY_STRING,
      error_name: error.name,
      error_message: error.message,
      ...other_details
    }
  };
}

/*
 * Used to track when a user has clicked one of the presented buttons
 * within an error message popup that is displayed.
 */
export function clickedErrorButton(
  error_button_type: ErrorModalButtonType
): AmplitudeEvent<ClickedErrorButton> {
  return {
    action: TrackingAction.ClickedErrorButton,
    category: "error",
    details: {
      error_button_type: error_button_type
    }
  };
}
